import ky from 'ky';

const api = ky.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set(
          'Authorization',
          `Bearer ${document.getElementById('root').getAttribute('data-key')}`
        );
      },
    ],
  },
});

const formDataApi = ky.create({
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set(
          'Authorization',
          `Bearer ${document.getElementById('root').getAttribute('data-key')}`
        );
      },
    ],
  },
});

export async function getUser() {
  if (!document.getElementById('root').getAttribute('data-key')) return null;

  return await api.get('/api/users/1').json();
}

export async function deleteUser() {
  return await api.delete('/api/users/1').json();
}

export async function getFonts() {
  return await api
    .get('/api/fonts')
    .json()
    .then((data) => {
      return data.map((font) => ({
        value: font.identifier,
        label: font.name,
        metadata: font.data,
      }));
    });
}

export async function getThemes() {
  if (!document.getElementById('root').getAttribute('data-key')) return null;

  return await api.get('/api/themes').json();
}

export async function createTheme(theme: any) {
  if (!document.getElementById('root').getAttribute('data-key')) return null;

  return await api.post('/api/themes', { json: theme }).json();
}

export async function updateTheme(theme: any) {
  if (!document.getElementById('root').getAttribute('data-key')) return null;

  return await api
    .put(`/api/themes/${theme.id}?presentation_id=${theme.presentationId}`, { json: theme })
    .json();
}

export async function uploadLogo(theme: any) {
  return await formDataApi
    .put(`/api/themes/${theme.get('id')}?presentation_id=${theme.get('presentationId')}`, {
      body: theme,
    })
    .json();
}

export async function createPresentation() {
  return await api.post('/api/presentations', { json: { origin: 'app' } }).json();
}

export async function updatePresentation(presentation) {
  if (!document.getElementById('root').getAttribute('data-key')) return null;

  return await api
    .put(`/api/presentations/${presentation.id}`, {
      json: presentation,
    })
    .json();
}

export async function createSlide({ presentation_id, index }) {
  return await api
    .post(`/api/presentations/${presentation_id}/slides`, {
      json: { index },
    })
    .json();
}

export async function updateSlide(slide) {
  return await api
    .put(`/api/presentations/${slide.presentation_id}/slides/${slide.id}`, {
      json: slide,
    })
    .json();
}

export async function deleteSlide(slide) {
  return await api.delete(`/api/presentations/${slide.presentation_id}/slides/${slide.id}`).json();
}

export async function deleteTheme(id) {
  return await api.delete(`/api/themes/${id}`).json();
}

export async function getPresentation(id, password = null) {
  let baseUrl = `/api/presentations/${id}`;
  if (password) {
    baseUrl += `?password=${password}`;
  }
  return await api.get(baseUrl).json();
}

export async function deletePresentation(id) {
  return await api.delete(`/api/presentations/${id}`).json();
}

export async function getWorkspace() {
  return await api.get(`/api/workspaces/0`).json();
}

export async function addUserToWorkspace(email) {
  return await api
    .get(`/api/workspaces/add_user`, {
      json: { email: email.trim() },
    })
    .json();
}

export async function removeUserFromWorkspace(email) {
  return await api.delete(`/api/workspaces/remove_user`, { json: { email } });
}

export async function createImage(file, presentation_id) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('presentation_id', presentation_id);
  return await formDataApi.post('/api/files', { body: formData }).json();
}

export async function getImage(src) {
  return await api.get(`/api/files/${src}`).json();
}

export async function createCheckoutSession({ price, email }) {
  return await api.post(`/api/stripe/create_checkout_session`, { json: { price, email } }).json();
}

export async function fetchCheckoutSession(sessionId) {
  return await api
    .post(`/api/stripe/fetch_checkout_session`, { json: { session_id: sessionId } })
    .json();
}
